<template>
  <v-navigation-drawer app :value="value" @input="$emit('input', $event)">
    <v-img class="my-6" src="@/assets/logo.png" height="100" contain></v-img>

    <v-divider></v-divider>

    <v-list dense nav>
      <v-list-item-group color="accent">
        <v-list-item
          v-for="link in links"
          :key="link.text"
          link
          :to="link.route"
        >
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'TheSidebar',
  props: ['value'],
  data() {
    return {
      links: [
        {
          icon: 'mdi-pier-crane',
          text: 'Vessels',
          route: '/'
        },
        {
          icon: 'mdi-account-plus',
          text: 'User Admin',
          route: '/user-admin'
        }
      ]
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
